const NAME = "MY_DIGITAL_DOCUMENTS";

export default NAME;
